import React, { useEffect, useMemo, useState, useContext, useRef } from "react";
import { Link, json, useNavigate,useSearchParams } from "react-router-dom";
import { useEntityCrud } from "../../hooks/useEntityCrud";
import { toast } from "react-toastify";
import ReactSelect from "react-select";
import { Context } from "../../context/UserContext";
import { QRCode } from 'react-qrcode-logo';
import ReactToPrint from 'react-to-print';
import "./Index.css"
import QRCodeModal from "./QRCodeModal";
import { NumericFormat } from "react-number-format";
import Pagination from "../Common/Pagination";


const Index = () => {
    const context = useContext(Context);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const [guildId, setGuildId] = useState(searchParams.get('guildId') || 0);

    const { readData } = useEntityCrud(guildId ? `Business/GetAllBusiness?guildId=${guildId}` : 'Business/GetAllBusiness');
    const { readData: filterData } = useEntityCrud("Business/GetAllBusinesses");
    const { addData: updateData } = useEntityCrud("Business/ChangeBusinessStatus");
    const { readData: getSupportPhone } = useEntityCrud('Config/get');

    const roleIdForDetail = useMemo(() => JSON.parse(localStorage.getItem("user"))?.roleId,[]);
    const businessIdForDetail = useMemo(() => JSON.parse(localStorage.getItem("user"))?.businessId,[]);

    const [showLoading,setShowLoading] = useState(true);
    const [businessId, setBusinessId] = useState(0);
    const { addData: setDeliverPrice } = useEntityCrud("Business/setDeliverPrice");
    const { readData: getDeliverPrice } = useEntityCrud(`Business/GetDeliverPrice?businessId=${businessIdForDetail}`);
    const { readData: getSubGuilds } = useEntityCrud(`Guild/GetAllSubGuilds?guildId=${guildId}`);
    const [deliverPriceShow, setDeliverPriceShow] = useState("");
    
    
    
    const [allRows, setAllRows] = useState([]);
    const [isFetched, setIsFetched] = useState(false);
    const [rows, setRows] = useState([]);
    const [statusFilter, setStatusFilter] = useState(1);
    const qrCodeContainerRef = useRef();
    
    const [title, setTitle] = useState("");
    const [terminalNo, setTerminalNo] = useState("");
    const [isActive, setIsActive] = useState("");
    const [contractStatus, setContractStatus] = useState('0');

    const [subGuilds,setSubGuilds] = useState([]);
    const [subGuildId,setSubGuildId] = useState('')
    const [cellphone,setCellphone] = useState('')
    const [nationalCode,setNationalCode] = useState('')
    
    const { addData: updateRulesApi } = useEntityCrud('Business/updateRule');
    const [rule,setRule] = useState('');
    const [currentBusiness,setCurrentBusiness] = useState({});

    const [titleForBusiness, setTitleForBusiness] = useState("");
    const [terminalForBusiness, setTerminalForBusiness] = useState("");


    const { readDataGet: readProvines } = useEntityCrud("Info/GetProvinces");
    const [provinces, setProvinces] = useState([]);
    const [provinceId, setProvinceId] = useState(0);

    const { readDataGet: readCities } = useEntityCrud(
        "Info/GetCities?provinceId=" + provinceId
    );
    const [cities, setCities] = useState([]);
    const [cityId, setCityId] = useState(0);

    const { readData: readDataGuilds } = useEntityCrud("Guild/GetAllGuilds");
    const [guilds, setGuilds] = useState([]);

    const [globalFilters, setGlobalFilters] = useState({});
    const [supportPhone,setSupportPhone] = useState('');

    const [isAdvanced, setIsAdvanced] = useState(false);
    const [showItem, setShowItem] = useState(true);
    const [isLoading, setLoading] = useState(false);

    const [deliveryPrice, setDeliveryPrice] = useState("");
    const [qrCodeText, setQRCodeText] = useState("");

    const [lastPage,setLastPage] = useState(0);

    const [pages, setPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [count,setCount] = useState(0);

    const [businessStatus,setBusinessStatus] = useState('');

    const isFinancialUser = localStorage.getItem('rl') == 363;

    useEffect(() => {
        if(guildId){
            setSubGuilds([])
            getSubGuilds().then(({ data }) => {
                if(data.status){
                    let getSubGuilds = [];
                    data.result.map(item => getSubGuilds.push({
                        label: item.title,
                        value: item.id
                    }))
                    setSubGuilds(getSubGuilds);
                }
            })
        }
    },[guildId])

    useEffect(() => {
        if (isActive === 1 || isActive === 2) {
            const filters = {
                title: title,
                guildId: guildId || 0,
                subGuildId: 0,
                subGuildtitle: "",
                address: "",
                phone: "",
                contractId: 0,
                isActive: isActive === 1 ? true : false,
                guildTitle: "",
                terminalNo: terminalNo,
                serialNo: "",
                acceptorId: "",
                website: "",
                telegram: "",
                instagram: "",
                lat: "",
                lang: "",
                logo: "",
                cityId: cityId || 0,
                provinceId: provinceId || 0,
                photo1: "",
                photo2: "",
                photo3: "",
                photo4: "",
                photo5: "",
                photo6: "",
                terminals: [
                    {
                        terminalNo: "",
                        serialNo: "",
                        acceptorId: "",
                        businessId: 0,
                    },
                ],
                registerDate: "2023-08-13T14:00:10.694Z",
            };
            if(businessStatus)
                filters.businessStatus = businessStatus;
            else
                delete filters.businessStatus;
            if(contractStatus == 1)
                filters.contractStatus = true;
            else
                delete filters.contractStatus;
            if(cellphone || nationalCode){
                filters.person = {}
                if(cellphone)
                    filters.person.cellphone = cellphone
                if(nationalCode)
                    filters.person.nationalCode = nationalCode
            }
            setGlobalFilters(filters);
        } else {
            const filters = {
                title: title,
                guildId: guildId || 0,
                subGuildId: 0,
                subGuildtitle: "",
                address: "",
                phone: "",
                contractId: 0,
                guildTitle: "",
                terminalNo: terminalNo,
                serialNo: "",
                acceptorId: "",
                website: "",
                telegram: "",
                instagram: "",
                lat: "",
                lang: "",
                logo: "",
                cityId: cityId || 0,
                provinceId: provinceId || 0,
                photo1: "",
                photo2: "",
                photo3: "",
                photo4: "",
                photo5: "",
                photo6: "",
                terminals: [
                    {
                        terminalNo: "",
                        serialNo: "",
                        acceptorId: "",
                        businessId: 0,
                    },
                ],
                registerDate: "2023-08-13T14:00:10.694Z",
            };
            if(businessStatus)
                filters.businessStatus = businessStatus;
            else
                delete filters.businessStatus;
            if(contractStatus == 1)
                filters.contractStatus = true;
            else
                delete filters.contractStatus;
            if(cellphone || nationalCode){
                filters.person = {}
                if(cellphone)
                    filters.person.cellphone = cellphone
                if(nationalCode)
                    filters.person.nationalCode = nationalCode
            }
            setGlobalFilters(filters);
        }
    }, [title, guildId, subGuildId, cellphone, nationalCode, terminalNo, cityId, isActive, provinceId,contractStatus,businessStatus]);

    const getReportsData = () => {
        setShowItem(false);
        setIsFetched(false);
        setIsAdvanced(true);
        setLoading(true);
        setRows([]);
        const postedData = {
            offset: 0,
            limit: 10,
            ...globalFilters
        };
        filterData(postedData).then(({ data }) => {
            setShowItem(true);
            setLoading(false);
            if (data.result) {
                setRows(data.result);
                calcPages(data)
            } else setRows([]);
        }).finally(() => {
            setIsFetched(true)
            setShowLoading(false);
        });
    };

    useEffect(() => {
        readProvines().then((res) => {
            setProvinces(res.data.result);
        });

        readDataGuilds().then((res) => {
            setGuilds([...res.data.result.filter(i => i.isActive)]);
        });

        getSupportPhone({key: 'support_phone'}).then(({data}) => {
            setSupportPhone(data.result.value)
        })
    }, []);

    /*   const downloadQRCode = () => {
            
            const canvas = qrCodeRef.current.querySelector('canvas');
            const pngUrl = canvas
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream");
            let downloadLink = document.createElement("a");
            downloadLink.href = pngUrl;
            downloadLink.download = "QRCode.png";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        };
         */

    useEffect(() => {
        readCities().then((res) => {
            setCities(res.data.result);
        });
    }, [provinceId]);

    const provincesAll = useMemo(() =>
        provinces?.map((item) => ({ value: item.id, label: item.title }))
    );

    const citiesAll = useMemo(() =>
        cities?.map((item) => ({ value: item.id, label: item.title }))
    );

    const GuildsAll = useMemo(() =>
        guilds?.map((item) => ({ value: item.id, label: item.title }))
    );

    const getData = () => {
        setIsFetched(false);
        const postedData = {
            offset: 0,
            limit: 10
        };
        if(guildId)
            postedData.guildId = parseInt(guildId);
        readData(postedData).then(({ data }) => {
            if (data.status) {
                setAllRows(data.result);
                setRows(data.result);
                calcPages(data)
            }
        }).finally(() => {
            setShowLoading(false);
            setIsFetched(true)
        });
    };

    const downloadExcel = () => {
        const postedData = {
            excelOutput: true,
            ...globalFilters
        };
        if(guildId)
            postedData.guildId = parseInt(guildId);
        console.log(postedData);
        
        readData(postedData).then(({ data }) => {
            if (data.status) {
                window.open(data.excelPath);
            }
        }).finally(() => {
            setShowLoading(false);
        });
    };

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        if (statusFilter == 1) setRows(allRows);
        else if (statusFilter == 2) setRows(allRows.filter((r) => r.isActive));
        else setRows(allRows.filter((r) => !r.isActive));
    }, [statusFilter]);

    const calcPages = res => {
        let calcPages = res.count / 10;
        setCount(res.count)
        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setLastPage(pagesArray.length)
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const changePage = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);

        let postedData = {
            limit: 10,
            offset: page - 1
        };

        if(guildId)
            postedData.guildId = guildId
        if(isAdvanced){
            postedData = {...postedData,...globalFilters}
            filterData(postedData).then(res => {
                setRows(res.data.result);
            }).catch(err => err.data.errors.map(error => toast.error(error.message)));
        }else{
            readData(postedData).then(res => {
                setRows(res.data.result);
            }).catch(err => err.data.errors.map(error => toast.error(error.message)));
        }
    }

    const prevPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage - 1);

        let postedData = {
            limit: 10,
            offset: currentPage - 2
        };

        if(guildId)
            postedData.guildId = guildId
        if(isAdvanced){
            postedData = {...postedData,...globalFilters}
            filterData(postedData).then(res => {
                setRows(res.data.result);
            }).catch(err => err.data.errors.map(error => toast.error(error.message)));
        }else{
            readData(postedData).then(res => {
                setRows(res.data.result);
            }).catch(err => err.data.errors.map(error => toast.error(error.message)));
        }
    }

    const nextPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage + 1);

        let postedData = {
            limit: 10,
            offset: currentPage
        };

        if(guildId)
            postedData.guildId = guildId
        if(isAdvanced){
            postedData = {...postedData,...globalFilters}
            filterData(postedData).then(res => {
                setRows(res.data.result);
            }).catch(err => err.data.errors.map(error => toast.error(error.message)));
        }else{
            readData(postedData).then(res => {
                setRows(res.data.result);
            }).catch(err => err.data.errors.map(error => toast.error(error.message)));
        }
    }

    const deActiveRow = (id) => {
        const postedData = {
            id,
            businessStatus: 5
        };
        updateData(postedData).then(({ data }) => {
            if (data.status) {
                toast.success("وضعیت کسب و کار مورد نظر با موفقیت به روزرسانی شد");
                const oldRows = [...rows];
                const index = oldRows.findIndex(row => row.id == id);
                oldRows[index].businessStatus = 5;
                setRows([...oldRows]);
            } else data.errors.map((error) => toast.error(error.message));
        });
    };

    const activeRow = (id) => {
        const postedData = {
            id,
            businessStatus: 4
        };
        updateData(postedData).then(({ data }) => {
            if (data.status) {
                toast.success("وضعیت کسب و کار مورد نظر با موفقیت به روزرسانی شد");
                const oldRows = [...rows];
                const index = oldRows.findIndex(row => row.id == id);
                oldRows[index].businessStatus = 4;
                setRows([...oldRows]);
            } else data.errors.map((error) => toast.error(error.message));
        });
    };

    const resetAdvancedSearch = (e) => {
        setShowItem(false);
        setIsFetched(false);
        setIsAdvanced(false);
        setLoading(true);
        setRows([]);

        setGuildId(0);
        setCityId(0);
        setProvinceId(0);
        setIsActive("");
        setTerminalNo("");
        setTitle("");
        const postedData = { offset: 0, limit: 10 };
        readData(postedData).then(({ data }) => {
            setLoading(false);
            setShowItem(true);
            if (data.result) {
                setRows(data.result);
                calcPages(data)
            } else setRows([]);
        }).finally(() => {
            setShowLoading(false);
            setIsFetched(true)
        });
    };

    let qrCodeRef = useRef();

    const downloadQRCode = () => {
        const svg = document.getElementById("QRCode");
        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();

        img.onload = () => {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            const pngFile = canvas.toDataURL("image/png");
            const downloadLink = document.createElement("a");
            downloadLink.download = "QRCode";
            downloadLink.href = `${pngFile}`;
            downloadLink.click();
        };
        img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
    };

    const sendDeliveryPrice = (it) => {
        debugger
        const postedData = {
            "price": deliveryPrice ? parseInt(deliveryPrice.toString().replace(/,/g, '')) : 0,
            "businessId": it
        }

        setDeliverPrice(postedData).then(res => {
            debugger
            if (res.data.status) {
                toast.success("با موفقیت ثبت شد.");
                getData();
                setDeliveryPrice("")
            }
        })

    }


    useEffect(() => {
        debugger
        getDeliverPrice().then(res => {
            debugger
            if (res.data.status) {
                setDeliverPriceShow(res.data.result)
            }
        })
    }, [businessIdForDetail])

    const setCurrentBusinessAction = business => {
        setCurrentBusiness(business)
        setRule(business.rule || '')
    }

    const updateRules = () => {
        const postedData = {
            businessId: currentBusiness.id,
            rule
        }
        updateRulesApi(postedData).then(({ data }) => {
            if(data.status){
                setRule('')
                toast.success('قوانین کسب و کار مورد نظر با موفقیت به روزرسانی شد')
                getData()
            }else
                data.errors.map((error) => toast.error(error.message))
        })
    }

    const openQrList = () => {
        localStorage.setItem('filter-data',JSON.stringify(globalFilters))
        setTimeout(() => {
            window.open('/business-qr');
        },250)
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">کسب و کار ها</div>
                {searchParams.has('guildId') && <a className="backIconLink" onClick={() => navigate(-1)}><i className="fa fa-arrow-left" title="بازگشت"></i></a>}
            </div>

            <div className="card-body" style={{minHeight: roleIdForDetail !== 3 ? 250 : 'auto'}}>
                {context.checkHasPermission("create") ? (
                    <>
                        <Link className="btn btn-primary" to="create">
                            ایجاد کسب و کار
                        </Link>
                        <button className="btn btn-secondary ms-2" onClick={openQrList}>دریافت لیست QrCode ها</button>
                    </>
                ) : (
                    ""
                )}
                {roleIdForDetail !== 3 && !isFinancialUser ? <button
                    className="btn btn-success ms-2"
                    aria-expanded="false"
                    onClick={downloadExcel}>
                    دریافت خروجی اکسل
                </button> : ''}
                {roleIdForDetail !== 3 ? (
                    <>
                        <button className={`btn btn-dark ${!isFinancialUser ? 'mx-2' : ''} accordion-toggle collapsed`} data-bs-toggle="collapse" data-bs-parent="#accordion" href="#collapseFour" aria-expanded="false">جستجو</button>
                        <div className="panel-group1" id="accordion1">
                            <div
                                id="collapseFour"
                                className="panel-collapse collapse position-relative"
                                role="tabpanel"
                                aria-expanded="false"
                            >
                                <div className=" row py-3">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label> عنوان </label>
                                            <input
                                                className="form-control"
                                                placeholder="عنوان ..."
                                                value={title}
                                                onChange={(e) => setTitle(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label> استان </label>
                                            {provinceId ? (
                                                <i
                                                    className="fe fe-x clear-select-btn"
                                                    onClick={(e) => {
                                                        setProvinceId(0);
                                                        setProvinceId(0);
                                                    }}
                                                >
                                                    {" "}
                                                </i>
                                            ) : (
                                                ""
                                            )}
                                            <ReactSelect
                                                noOptionsMessage={(e) => "یافت نشد"}
                                                placeholder="انتخاب کنید"
                                                options={provincesAll}
                                                value={provincesAll?.filter(
                                                    (b) => b.value == provinceId
                                                )}
                                                onChange={(e) => setProvinceId(e.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>شهر</label>
                                            {cityId ? (
                                                <i
                                                    className="fe fe-x clear-select-btn"
                                                    onClick={(e) => setCityId(0)}
                                                >
                                                    {" "}
                                                </i>
                                            ) : (
                                                ""
                                            )}
                                            <ReactSelect
                                                noOptionsMessage={(e) => "یافت نشد"}
                                                placeholder="انتخاب کنید"
                                                options={citiesAll}
                                                value={citiesAll?.filter((b) => b.value == cityId)}
                                                onChange={(e) => setCityId(e.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>صنف</label>
                                            {guildId ? (
                                                <i
                                                    className="fe fe-x clear-select-btn"
                                                    onClick={(e) => {setGuildId(0);setSubGuilds([]);setSubGuildId('')}}
                                                ></i>
                                            ) : (
                                                ""
                                            )}
                                            <ReactSelect
                                                noOptionsMessage={(e) => "یافت نشد"}
                                                placeholder="انتخاب کنید"
                                                options={GuildsAll}
                                                value={GuildsAll.filter((b) => b.value == guildId)}
                                                onChange={(e) => setGuildId(e.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>زیر صنف</label>
                                            {subGuildId ? (
                                                <i
                                                    className="fe fe-x clear-select-btn"
                                                    onClick={(e) => setSubGuildId(0)}
                                                ></i>
                                            ) : (
                                                ""
                                            )}
                                            <ReactSelect
                                                noOptionsMessage={(e) => "یافت نشد"}
                                                placeholder="انتخاب کنید"
                                                options={subGuilds}
                                                isDisabled={!subGuilds.length}
                                                value={subGuilds.filter((b) => b.value == subGuildId)}
                                                onChange={(e) => setSubGuildId(e.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label> پایانه </label>
                                            <input
                                                className="form-control ltr-input"
                                                value={terminalNo}
                                                onChange={(e) => setTerminalNo(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            {businessStatus !== "" ? (
                                                <i
                                                    className="fe fe-x clear-select-btn"
                                                    onClick={(e) => setBusinessStatus("")}
                                                ></i>
                                            ) : (
                                                ""
                                            )}
                                            <label> وضعیت </label>
                                            <ReactSelect
                                                noOptionsMessage={(e) => "یافت نشد"}
                                                placeholder="انتخاب کنید"
                                                options={[
                                                    { value: 1, label: "در انتظار تایید مالی" },
                                                    { value: 2, label: "تایید مالی" },
                                                    { value: 3, label: "عدم تایید مالی" },
                                                    { value: 4, label: "فعال" },
                                                    { value: 5, label: "غیرفعال" },
                                                ]}
                                                value={[
                                                    { value: 1, label: "در انتظار تایید مالی" },
                                                    { value: 2, label: "تایید مالی" },
                                                    { value: 3, label: "عدم تایید مالی" },
                                                    { value: 4, label: "فعال" },
                                                    { value: 5, label: "غیرفعال" },
                                                ].filter((b) => b.value === businessStatus)}
                                                onChange={(e) => setBusinessStatus(e.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            {isActive !== "" ? (
                                                <i
                                                    className="fe fe-x clear-select-btn"
                                                    onClick={(e) => setContractStatus("")}
                                                ></i>
                                            ) : (
                                                ""
                                            )}
                                            <label> وضعیت قرارداد </label>
                                            <ReactSelect
                                                noOptionsMessage={(e) => "یافت نشد"}
                                                placeholder="انتخاب کنید"
                                                options={[
                                                    { value: 0, label: "همه" },
                                                    { value: 1, label: "اتمام قرارداد" },
                                                ]}
                                                value={[
                                                    { value: 0, label: "همه" },
                                                    { value: 1, label: "اتمام قرارداد" },
                                                ].filter((b) => b.value === contractStatus)}
                                                onChange={(e) => setContractStatus(e.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label> کد ملی مالک </label>
                                            <input
                                                className="form-control ltr-input"
                                                maxLength={10}
                                                value={nationalCode}
                                                onChange={(e) => setNationalCode(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label> شماره همراه مالک </label>
                                            <input
                                                className="form-control ltr-input"
                                                maxLength={11}
                                                value={cellphone}
                                                onChange={(e) => setCellphone(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-center py-2">
                                        {showItem && (
                                            <>
                                                {" "}
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={getReportsData}
                                                >
                                                    جستجو
                                                </button>
                                                {isAdvanced && (
                                                    <button
                                                        className="btn btn-danger mx-2"
                                                        onClick={resetAdvancedSearch}
                                                    >
                                                        حذف فیلتر
                                                    </button>
                                                )}
                                            </>
                                        )}
                                        {isLoading && (
                                            <div className="lds-facebook mt-4">
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : ''}
                {showLoading ? <div className="loading-box">
                    <img src="/assets/images/loading.gif" alt="" />
                </div> : rows?.length ? <>
                    {roleIdForDetail !== 3 ? <div className="table-responsive mt-3">
                        <table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                            <thead>
                                <tr>
                                    <th>ردیف</th>
                                    <th>عنوان</th>
                                    <th>شماره تماس</th>
                                    <th>نام و نام خانوادگی</th>
                                    <th>صنف</th>
                                    <th>زیر صنف</th>
                                    <th>وضعیت</th>
                                    <th>عملیات</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{(index + 1) + (currentPage > 1 ? (currentPage - 1) * 10 : '')}</td>
                                        <td>{item.title || "-"}</td>
                                        <td>{item.phone || "-"}</td>
                                        <td>{(item?.person?.name || '') + ' ' + (item?.person?.lastName || '-')}</td>
                                        <td>{item.guildTitle || "-"}</td>
                                        <td>{item.subGuildTitle || "-"}</td>
                                        <td>
                                            {item.businessStatus == 1 && 'در انتظار تایید مالی'}
                                            {item.businessStatus == 2 && 'تایید مالی'}
                                            {item.businessStatus == 3 && 'عدم تایید مالی'}
                                            {item.businessStatus == 4 && 'فعال'}
                                            {item.businessStatus == 5 && 'غیرفعال'}
                                            {!item.businessStatus && '-'}
                                        </td>
                                        <td className="btn-list">
                                            {context.checkHasPermission("update") ? (
                                                <>
                                                    <Link
                                                        to={"update/" + item.id}
                                                        className="btn btn-icon mb-0 btn-primary"
                                                        title="ویرایش"
                                                    >
                                                        <i className="fe fe-edit-2"></i>
                                                    </Link>
                                                    {!isFinancialUser && <button
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#change-rules"
                                                        className="btn btn-icon mb-0 btn-secondary"
                                                        title="ویرایش قوانین"
                                                        onClick={() => setCurrentBusinessAction(item)}
                                                    >
                                                        <i className="fe fe-file-text"></i>
                                                    </button>}
                                                    {!isFinancialUser && <Link
                                                        to={`/services-managment?businessId=${item.id}`}
                                                        className="btn btn-icon mb-0 btn-dark"
                                                        title="مدیریت محصول / خدمات"
                                                    >
                                                        <i className="fe fe-settings"></i>
                                                    </Link>}
                                                </>
                                            ) : (
                                                ""
                                            )}
                                            {roleIdForDetail === 1 && (
                                                <>
                                                    {context.checkHasPermission("update") ? (
                                                        <Link
                                                            to={"contracts/" + item.id}
                                                            className="btn btn-icon mb-0 btn-warning"
                                                            title="قرارداد ها"
                                                        >
                                                            <i className="fe fe-clipboard"></i>
                                                        </Link>
                                                    ) : (
                                                        ""
                                                    )}
                                                </>
                                            )}
                                            {context.checkHasPermission("delete") ? (
                                                item.businessStatus == 4 ? (
                                                    <button
                                                        onClick={(e) => deActiveRow(item.id)}
                                                        className="btn btn-icon mb-0 btn-danger"
                                                        title="غیرفعال سازی"
                                                    >
                                                        <i className="fe fe-x"></i>
                                                    </button>
                                                ) : (
                                                    <button
                                                        onClick={(e) => activeRow(item.id)}
                                                        className="btn btn-icon mb-0 btn-success"
                                                        title="فعال سازی"
                                                    >
                                                        <i className="fe fe-check"></i>
                                                    </button>
                                                )
                                            ) : (
                                                ""
                                            )}
                                            {context.checkHasPermission("update") ? (

                                                !isFinancialUser && <button
                                                    className="btn btn-icon mb-0 btn-info"
                                                    data-bs-toggle="modal"
                                                    href={`#modaldemo${item.id}`}
                                                    title="دریافت QR Code"
                                                    onClick={() => {
                                                        setTerminalForBusiness(item.terminalNo)
                                                        setTitleForBusiness(item.title)
                                                    }}
                                                >
                                                    <i className="fa fa-qrcode"></i>
                                                </button>
                                            ) : (
                                                ""
                                            )}

                                            {/*              {context.checkHasPermission("update") ? (
                                                <button
                                                    className="btn btn-icon mb-0 btn-secondary"
                                                    title="هزینه ارسال"
                                                    data-bs-toggle="modal"
                                                    href={`#modaldemoDelivery${item.id}`}
                                                    onClick={() => setBusinessId(item.id)}
                                                >
                                                    <i className="fa fa-send"></i>
                                                </button>
                                            ) : (
                                                ""
                                            )} */}




                                            <QRCodeModal
                                                ID={`modaldemo${item.id}`}
                                                terminalForBusiness={terminalForBusiness}
                                                titleForBusiness={titleForBusiness}
                                                phoneForBusiness={supportPhone}
                                            />


                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <p>تعداد کل ردیف ها : {count || rows.length}</p>
                        <Pagination changePage={changePage} currentPage={currentPage} pages={pages} prevPageClick={prevPage} nextPageClick={nextPage} lastPage={lastPage} />
                    </div> : <>
                        <div className="row justify-content-center">
                            <div className="col-lg-2 col-md-3 col-6">
                                <button className="btn btn-primary btn-block" onClick={() => navigate("update/" + rows[0].id)}><i className="fe fe-edit-2"></i> ویرایش اطلاعات</button>
                            </div>
                            {/* <div className="col-lg-2 col-md-3 col-6">
                                <button className="btn btn-secondary btn-block" data-bs-toggle="modal" href={`#modaldemo${rows[0].id}`}
                                    onClick={() => {
                                        setTerminalForBusiness(rows[0].terminalNo)
                                        setTitleForBusiness(rows[0].title)
                                    }}><i className="fa fa-qrcode"></i> دریافت QRCode</button>
                            </div> */}

                            <div className="col-lg-2 col-md-3 col-6">
                                <button className="btn btn-info btn-block"
                                    data-bs-toggle="modal"
                                    href={`#modaldemoDelivery${rows[0].id}`} >
                                    <i className="fe fe-send"></i>
                                    هزینه ارسال
                                </button>
                            </div>

                            <div className="modal fade" id={`modaldemoDelivery${rows[0].id}`}>
                                <div className="modal-dialog modal-dialog-centered "
                                    role="document">
                                    <div className="modal-content modal-content-demo">
                                        <div className="modal-header">
                                            <h6 className="modal-title">  هزینه ارسال (ریال) </h6>
                                            <button
                                                aria-label="Close"
                                                className="btn-close"
                                                data-bs-dismiss="modal">
                                                <span aria-hidden="true ">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body my-4">


                                            {deliverPriceShow && <div className="alert alert-light" role="alert">
                                                <i className="fa fa-bell-o me-2" aria-hidden="true"></i>
                                                هزینه ارسال فعلی
                                                <span className="mx-2">
                                                    {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(deliverPriceShow)}
                                                </span>   ریال
                                                می باشد.
                                                در صورت تغییر ،مبلغ جدید را وارد کنید  .

                                            </div>}

                                            <NumericFormat
                                                name="deliveryPrice"
                                                className="form-control ltr-input"
                                                value={deliveryPrice}
                                                isRtl={true}
                                                onChange={(e) => setDeliveryPrice(e.target.value)}
                                                thousandSeparator=","
                                                allowNegative={false}
                                            />

                                            <a className="btn btn-success btn-block text-white my-2" data-bs-dismiss="modal" onClick={() => sendDeliveryPrice(rows[0].id)}> ثبت </a>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <QRCodeModal
                            ID={`modaldemo${rows[0].id}`}
                            terminalForBusiness={terminalForBusiness}
                            titleForBusiness={titleForBusiness}
                            phoneForBusiness={supportPhone}
                        />
                    </>}
                </> : (
                    isFetched ? <div className="alert alert-info mt-3">
                    <p>سازمانی یافت نشد</p>
                </div> : ''
                )}
            </div>
            <div className="modal fade" id="change-rules" tabindex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5">به روزرسانی قوانین {currentBusiness?.title}</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label>قوانین و مقررات</label>
                            <textarea rows="6" className="form-control" onChange={e => setRule(e.target.value)} value={rule}></textarea>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">لغو</button>
                        <button type="button" className="btn btn-success" onClick={updateRules} data-bs-dismiss="modal">به روزرسانی</button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;
